import { createStyles, Theme } from '@material-ui/core/styles';

import { getCommonStyles } from '@shared/components/select-new/Select.styles';
import { colors, colours } from '@shared/theme/colours';

export function styles(theme: Theme) {
  const commonStyles = getCommonStyles(theme);

  return createStyles({
    // ---- Override common styles ----

    ...commonStyles,

    // ---- Component styles ----

    // Error
    errorText: {
      color: '#B42318', //TODO replace after new palette creating
      fontSize: 14,
    },

    // Group
    group: {},
    groupItem: {
      padding: theme.spacing(2, 0, 0),
    },
    // Potentially restyle to match new design
    groupLabel: {
      textTransform: 'uppercase',
      color: colors.grey.main,
      display: 'block',
      padding: theme.spacing(1, 2),
      fontSize: 12,
      fontWeight: 300,
    },

    // Label
    labelRoot: {
      // TODO: Make this consistent with TextField styling, when time permits. -Ben
      fontSize: 14,
      marginBottom: theme.spacing(2),
      color: '#1D2433', //TODO replace after new palette creating
    },
    labelError: {
      color: '#C52810 !important', //TODO replace after new palette creating
    },
    helperText: {
      paddingTop: theme.spacing(1),
    },

    // Value
    value: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      overflow: 'hidden',
      marginTop: 2,
      textOverflow: 'ellipsis',
      width: '100%',
      textAlign: 'left',
    },
    valueDisabled: {},
    valueMultiple: {},
    valuePlaceholder: {
      color: 'currentColor',
      display: 'inline-flex',
      fontSize: 'inherit',
      opacity: 0.42,
    },

    valueIcon: {
      alignItems: 'center',
      display: 'inline-flex',
      fontSize: 16,
      paddingRight: theme.spacing(2),

      '& svg': {
        fontSize: 'inherit',
      },
      '& svg path': {},
      '& i': {
        fontSize: 'inherit',
      },
    },
    valueText: {
      color: 'currentColor',
      fontSize: 'inherit',
      lineHeight: 20,
      opacity: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },

    //Tooltip
    tooltip: {},

    // Search
    search: {
      padding: theme.spacing(2),
    },
    searchInput: {
      width: '100%',
    },

    // Utility classes - DO NOT STYLE
    menuItemActive: {},
  });
}
